// Boot-stage breadcrumbs for the white-screen watchdog. Each call appends a
// stage marker (with ms-since-boot) to window.__bootCrumbs — maintained by the
// inline script in index.html, which attaches the trail to a white-screen
// record. A silent stall then shows the LAST stage boot reached instead of
// nothing. No-op when the inline script didn't run (tests, non-browser).
export function markBootStage(stage: string): void {
  try {
    (window as unknown as { __crumb?: (s: string) => void }).__crumb?.(stage);
  } catch {
    // telemetry must never break startup
  }
}
